import { DomainBase } from "./DomainBase";

export class ProductTypes extends DomainBase {
    constructor() {
        super();
        this.name="";
    }
}